
import { Inject, Injectable, LOCALE_ID } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve,  } from "@angular/router";
import { Observable } from 'rxjs/internal/Observable';
import { environment } from "src/environments/environment";
import { CanonicalService } from "../services/canonical.service";
import { JsonldService } from "../services/jsonld.service";
import { MetaSeoService } from "../services/meta-seo.service";

@Injectable({
    providedIn: 'root',
  })
  export class CapitalIncreaseMercenaryResolver implements Resolve<Object> {
    constructor(
      private canonicalService: CanonicalService,
      @Inject(LOCALE_ID) private localId: Object,
      public jsonldService: JsonldService,
      private seoService:MetaSeoService,
    ){}

    resolve(route: ActivatedRouteSnapshot): Observable<Object> {
      const subSuffex="/capital-increase/mercenary/"
      const domain=environment.domain;
      const lang=String(this.localId).substring(0, 2);
      let domainAndLangURL = `${domain}/${lang}`;
      let canonicalURL = domainAndLangURL+subSuffex;
      let titlePrefix =`Mercenary Capital Increase`
      let title = `${titlePrefix}  | Halka Arz Info`;
      let description =`Browse the current list of companies conducting mercenary capital increases. Gain insights on the details of capital augmentation, the rates of increase, and the potential returns for shareholders. Find key dates and announcements of capital increases to support your decision-making process.`;
      if(lang == "tr"){
        titlePrefix = `Bedelli Sermaye Artırımı`
        title = `${titlePrefix}  | Halka Arz Info`;
        description = `Bedelli Sermaye Artırımı yapan şirketlerin güncel listesine göz atın. Şirketlerin sermaye artırımı detayları, artırım oranları ve hissedarlar için potansiyel getiriler hakkında bilgi edinin. Karar verme sürecinizi destekleyecek önemli tarihleri ve sermaye artırımı duyurularını burada bulun.`;
      }
      this.canonicalService.setCanonicalURLForId(canonicalURL);
      this.seoService.setMetaAndTitle(title,description,canonicalURL,domainAndLangURL,"");
      this.canonicalService.setWrapperAlternate(domain,subSuffex);
      this.jsonldService.removeJsonSnippet();
      this.jsonldService.setOrganization();
      this.jsonldService.setWebSiteType(domain,lang);
      this.jsonldService.setTableType(titlePrefix);
      return null;
    }

}
